// import Swiper from 'swiper';
import Swiper from 'swiper/dist/js/swiper.js';

import { sharedData } from '../models/shared_data'

let initSwiper = function() {
  const params = {
    speed: 3000,
    navigation: {
      nextEl: '.arrow-right',
      prevEl: '.arrow-left',
    },
    parallax: true,
    loop: true,
    autoHeight: true
  }
  let sw = new Swiper('.swiper-container', params);
}

const initMaps = function() {
  let qs = document.querySelectorAll('.contact-map')
  if(qs.length == 0)
    return


  ymaps.ready(init);

  function init() {

    for(let node of qs) {
      const coords = JSON.parse(node.getAttribute('map-coords'))
      const addr = node.getAttribute('map-addr')
      let myMap = new ymaps.Map(node, {
          center: coords,
          zoom: 14
      });

      let myPlacemark = new ymaps.Placemark(coords, {
          hintContent: addr,
          balloonContent: addr
      });

      myMap.geoObjects.add(myPlacemark);
      myMap.behaviors.disable('scrollZoom');
    }

  }
}

var $ = require('jquery');

require('fancybox')($);

function initGalleries() {
  $('.fancy-box').fancybox()
}

function checkCatalogStick() {
  const offset = window.pageYOffset || document.documentElement.scrollTop
  if(window.innerWidth < 800)
    return
  if(offset > 400) {
    let el = $('.catalog-left-menu')
    if(!el.hasClass("fixed")) {
      el.addClass("fixed")
    }
  } else {
    let el = $('.catalog-left-menu')
    if(el.hasClass("fixed")) {
      el.removeClass("fixed")
    }

  }

}

function resizeStickyCatalog() {

}

function initStickyCatalog() {
  if($('.catalog-left-menu').length == 0)
    return
  var el = $('.catalog-left-menu')
  var w = el.outerWidth()

  if(!el.hasClass("fixed")) {
    el.css("width", w + "px")
  }

  checkCatalogStick()
  window.addEventListener('scroll', ()=> {
    checkCatalogStick()
  });
}

function onResize() {
  resizeStickyCatalog()
}


function initMobileMenuToggle() {
  $(document).on('click', '.mobile-menu-button', (e)=> {
    $('#mobile-menu').toggleClass('active')
    $('body').toggleClass('overflowed')
    setTimeout(()=> {
      $('.mobile-menu-button').toggleClass('is-active')
    }, 1)

  })
}


export default function() {
  if($('.main_page_slider').length > 0) {
    initSwiper()
  }

  $( window ).resize(()=> {
    onResize()
  });

  initMaps()
  initGalleries()
  
  if(sharedData.data.site_params.site_sticky_catalog)
    initStickyCatalog()

  initMobileMenuToggle()
}



// WEBPACK FOOTER //
// ./app/javascript/website_default/js/initializers/main_page.js